import { useEffect } from "react"

import { loadJsConditionally } from "../helpers/load-js-conditionally"

export const useStripe = () => {
  useEffect(() => {
    loadJsConditionally(`https://js.stripe.com/v3/`)
  }, [])
}
